<div class="confirmation-container">
    <div class="confirmation-content">
        <!-- Success State -->
        <div *ngIf="!isError">
            <div class="success-icon">✓</div>
            <h2>Krankmeldung erfolgreich erfasst</h2>
            <p>{{ successMessage }}</p>

            <div class="button-group">
                <button class="primary-button" (click)="onNewEntry()">
                    Neue Krankmeldung erfassen
                </button>
                <button class="secondary-button" (click)="onBackToHome()">
                    Zurück zur Startseite
                </button>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="isError">
            <div class="error-icon">✕</div>
            <h2>Fehler beim Erstellen der Krankmeldung</h2>
            <p>{{ errorMessage }}</p>

            <div class="button-group">
                <button class="primary-button" (click)="onRetry()">
                    Erneut versuchen
                </button>
                <button class="secondary-button" (click)="onBackToHome()">
                    Zurück zur Startseite
                </button>
            </div>
        </div>
    </div>
</div>